import React from "react";
import { ArrowDownIcon, CheckIcon } from "lucide-react";
import { frameworkStages, images, volumes } from "../../data/content";
import { CTAButton } from "../CTAButton";
export function Volumes() {
  return <section className="bg-cream px-4 py-16" data-id="element-302" data-mp="2x08j88lm9lrs">
      <div className="mx-auto max-w-3xl" data-id="element-303" data-mp="2x3cs3ja115os">
        <p className="text-center text-[13px] font-bold uppercase tracking-wider text-gold" data-id="element-304" data-mp="2t0g7xo4u91iq">What you’ll find inside</p>
        <h2 className="mt-2 text-center font-serif text-[32px] font-bold leading-tight text-ink sm:text-5xl" data-id="element-305" data-mp="2o1del0y80jql">
          6 premium volumes. One repeatable system.
        </h2>

        <img src={images.product} alt="All six volumes of the Lipo Revision Case Atlas" className="-mx-4 mt-6 block w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-xl" data-id="element-306" data-mp="2ea0l64wrxlig" />

        {/* Volume I — the framework, featured */}
        <article className="mt-6 overflow-hidden rounded-3xl bg-ink text-white" data-id="element-307" data-mp="20b0uystm4yk6">
          <div className="p-5 sm:p-8" data-id="element-308" data-mp="20d3uq4kki623">
            <p className="text-[13px] font-bold uppercase tracking-wider text-gold" data-id="element-309" data-mp="3354crxtvld6s">Volume I</p>
            <h3 className="mt-1 font-serif text-[26px] font-bold leading-tight sm:text-3xl" data-id="element-310" data-mp="37ww3q9gy1kxg">
              The 15-Minute Revision Case Review Framework™
            </h3>
            <p className="mt-3 text-[16px] leading-relaxed text-white/80" data-id="element-311" data-mp="2u34s8vjnjqz3">
              Stop staring at a difficult revision case wondering where to begin. A structured educational framework that
              organizes your review into six repeatable stages:
            </p>
            <ol className="mt-6 space-y-0" data-id="element-312" data-mp="3qufd5e7bd5ke">
              {frameworkStages.map((s, i) => <li key={s.name} className="relative flex gap-4 pb-5 last:pb-0" data-id="element-313" data-mp="3cuxocyu0psb1" data-mpi={i}>
                  {i < frameworkStages.length - 1 && <span className="absolute left-[19px] top-10 h-[calc(100%-2.5rem)] w-px bg-gold/40" aria-hidden data-id="element-314" data-mp="21gacud1ozhsh" />}
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold font-serif text-lg font-bold text-ink" data-id="element-315" data-mp="26gep1qvkhqcw">
                    {i + 1}
                  </span>
                  <div className="pt-1" data-id="element-316" data-mp="713j896qmvjl">
                    <p className="text-[18px] font-bold text-goldsoft" data-id="element-317" data-mp="72ejw04vzn6h">{s.name}</p>
                    <p className="text-[15px] leading-snug text-white/80" data-id="element-318" data-mp="27it13bdz5uy">{s.q}</p>
                  </div>
                </li>)}
            </ol>
            <p className="mt-6 rounded-xl bg-white/[0.07] p-4 text-[15px] leading-relaxed text-white/85" data-id="element-319" data-mp="3pebbwbfym9n5">
              Includes the <strong className="text-white" data-id="element-320" data-mp="3ke6wypup9mz1">15-Minute Revision Case Review Sheet™</strong>. The goal is not to
              replace clinical judgment — it’s to give your educational case review a consistent structure.
            </p>
          </div>
        </article>

        <div className="mt-5 space-y-5" data-id="element-321" data-mp="1dp0l35jluh1n">
          {volumes.map(v => <article key={v.n} className="rounded-3xl bg-white p-5 shadow-[0_1px_0_rgba(14,21,36,0.06)] sm:p-8" data-id="element-322" data-mp="19mx9mgwxrcgd">
              <p className="text-[13px] font-bold uppercase tracking-wider text-gold" data-id="element-323" data-mp="2rks4nii1nlbn">Volume {v.n}</p>
              <h3 className="mt-1 font-serif text-[24px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-324" data-mp="2wjd5nk54e915">{v.title}</h3>
              <p className="mt-2 text-[17px] font-semibold text-navy" data-id="element-325" data-mp="31a3dd410qnz0">{v.lead}</p>
              <p className="mt-4 text-[15px] text-muted" data-id="element-326" data-mp="35cghxp414fu7">{v.intro}</p>

              {v.flow ? <ol className="mx-auto mt-4 max-w-xs" data-id="element-327" data-mp="28m7j05yx985e">
                  {v.items.map((it, i) => <li key={it} className="flex flex-col items-center" data-id="element-328" data-mp="2dk904lcsexe8" data-mpi={i}>
                      <span className="w-full rounded-xl bg-ink px-4 py-3 text-center text-[14px] font-bold uppercase tracking-wide text-goldsoft" data-id="element-329" data-mp="2dmlpvkosec1u">
                        {it}
                      </span>
                      {i < v.items.length - 1 && <ArrowDownIcon className="my-1 h-5 w-5 text-gold" aria-hidden data-id="element-330" data-mp="3t2aue5kfs2dx" />}
                    </li>)}
                </ol> : <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-331" data-mp="e1cm7vkl5sn">
                  {v.items.map(it => <li key={it} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-332" data-mp="3rkvnexg2tomx">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden data-id="element-333" data-mp="9f8whkxca437" />
                      {it}
                    </li>)}
                </ul>}

              <p className="mt-5 border-t border-sand pt-4 text-[15px] font-semibold italic leading-relaxed text-navy" data-id="element-334" data-mp="jcdldsikkdnp">
                {v.outro}
              </p>
            </article>)}
        </div>

        <CTAButton className="mt-10" label="I want all 6 volumes now" data-id="element-335" data-mp="t2ztz2rvc3ww" />
      </div>
    </section>;
}